import attendeeStatuses from 'constants/attendee-statuses';

export function sortAttendees(activity, user) {

  const meeting = activity.event;
  const attendees = meeting.attendees;
  const hostId = meeting.creatorId;
  const currentUserId = user._id;

  // sort attendees so that
  // current user comes first
  // if current user is not host, host comes second
  // then everyone else

  const sortedAttendees = attendees.sort((a, b) => {

    if (a._id === currentUserId) {
      return -1;
    } else if (b._id === currentUserId) {
      return 1;
    } else if (a._id === hostId) {
      return -1;
    } else if (b._id === hostId) {
      return 1;
    } else {
      return 0;
    }

  });

  return sortedAttendees;

}

export function determineAttendeeLabel(attendee, meetingHostId, currentUserId) {

  if (attendee._id === meetingHostId) {
    return 'Host';
  } else if (attendee._id === currentUserId) {
    return 'You';
  }

  return null;

}

export function convertAttendeeStatusToText(status) {

  if (status === attendeeStatuses.ACCEPTED) {
    return 'Going';
  } else if (status === attendeeStatuses.MAY_BE) {
    return 'May attend';
  } else if (status === attendeeStatuses.DECLINED) {
    return 'Declined';
  }

}